/** URL `page` query must be a positive integer. */
export function isPageValid(page: string): boolean {
  const parsed = parseInt(page, 10) || 0;
  return parsed > 0;
}

/** Coerce URL `page` query to a positive integer, defaulting to 1. */
export function getValidPage(page: string): number {
  const parsed = parseInt(page, 10) || 1;
  return parsed <= 0 ? 1 : parsed;
}

/**
 * Coerce URL `limit` query to a positive integer within (0, max], otherwise `fallback`.
 */
export function getValidLimit(
  limit: string,
  max: number,
  fallback: number,
): number {
  const parsed = parseInt(limit, 10);
  if (parsed > 0 && parsed <= max) {
    return parsed;
  }
  return fallback;
}
